// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './components/HomePage';
import Events from './components/Events/Events';
import AboutAICIS from './components/Events/AboutAICIS';
import AICIS2024 from './components/Events/AICIS2024';
import AICIC2025 from './components/Events/AICIC2025';
import PreSummit from './components/Events/PreSummit';
import GlobalSummit from './components/Events/GlobalSummit';
import Affiliate from './components/Affiliates/Affiliate';
import FAQ from './components/FAQ/FAQ';
import MediaRegistration from './components/Events/MediaRegistration';

// Activities
import Activities from './components/Activities/Activities';
import StrategicAlignment from './components/Activities/StrategicAlignment';
import HostCountryProfile from './components/Activities/HostCountryProfile';
import Objectives from './components/Activities/Objectives';
import InvitedHeads from './components/Activities/InvitedHeads';
import Speakers from './components/Activities/Speakers';
import SpeakersForm from './components/Activities/SpeakersForm';
import Schedule from './components/Activities/Schedule';

import Brochures from './components/Resources/Brochures';

// Policy
import Policy from './components/Policy/Policy';
import PolicyAgreement from './components/Policy/PolicyAgreement';
import Register from './components/Register/Register';


import './App.css';

// ===== SCROLL TO TOP COMPONENT =====
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <Routes>
          {/* Home */}
          <Route path="/" element={<HomePage />} />
          
          {/* Events */}
          <Route path="/events" element={<Events />} />
          <Route path="/events/about" element={<AboutAICIS />} />
          <Route path="/events/aicis-2024" element={<AICIS2024 />} />
          <Route path="/events/aicic-2025" element={<AICIC2025 />} />
          <Route path="/events/pre-summit" element={<PreSummit />} />
          <Route path="/events/global-summit" element={<GlobalSummit />} />
          <Route path="/media-registration" element={<MediaRegistration />} />
          
          {/* Affiliate */}
          <Route path="/affiliate" element={<Affiliate />} />
          
          {/* Activities */}
          <Route path="/activities" element={<Activities />} />
          <Route path="/activities/strategic-alignment" element={<StrategicAlignment />} />
          <Route path="/activities/host-country" element={<HostCountryProfile />} />
          <Route path="/activities/objectives" element={<Objectives />} />
          <Route path="/activities/invited-heads" element={<InvitedHeads />} />
          <Route path="/activities/speakers" element={<Speakers />} />
          <Route path="/speakers-form" element={<SpeakersForm />} />
          <Route path="/activities/schedule" element={<Schedule />} />

          <Route path="/resources/brochures" element={<Brochures />} />
          
          {/* Policy */}
          <Route path="/policy" element={<Policy />} />
          <Route path="/policy-agreement" element={<PolicyAgreement />} />
          
          {/* FAQ */}
          <Route path="/faq" element={<FAQ />} />
          
          {/* Blog - Coming Soon */}
          <Route path="/blog" element={<div className="coming-soon-page"><h1>Blog Coming Soon</h1></div>} />

          <Route path="/register" element={<Register />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;